import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// import { updatePlanModal, updatePlan, updatePlanPermissions } from 'store/user';
import { Tabs } from 'antd';
import merchantAPI from 'services/merchants';
import Alert from 'components/Alert';
import GeneralSettings from 'components/GeneralSettings';
import PartnerBaseRateWrapper from 'components/PartnerBaseRateWrapper/PartnerBaseRateWrapper';
import Notifications from 'components/Notifications';
import trackingService from 'services/trackingService';
import EVENT_NAME from 'utils/const';
// import SubscriptionTab from 'components/SubscriptionTab';
// import merchantAPI from 'services/merchants';

function Settings() {
  const user = useSelector((state) => state.user);
  /* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
  const partnerId = user?.currentUser?._id;
  const [productWiseMode, setProductWiseMode] = useState([]);
  const [updatedAt, setBaseRateUpdateAt] = useState(false);
  const [hasData, sethasData] = useState(false);

  // const planType = useSelector((state) => state.user.plan.plan_type);
  // const isTrialUsed = useSelector((state) => state.user.plan.trial_used);
  // const isTrialActivate = useSelector((state) => state.user.plan.trial_activate);
  // const currentTenure = useSelector((state) => state.user.plan.tenure);
  // const startDate = useSelector((state) => state.user.plan.start_date);
  // const endDate = useSelector((state) => state.user.plan.end_date);

  // const dispatch = useDispatch();

  // const activePlan = async (type, tenure, trial) => {
  //   const response = await merchantAPI.activatePlan({
  //     plan_type: type,
  //     tenure,
  //     trial
  //   });

  //   if (response.success) {
  //     dispatch(updatePlan(response.data));
  //     dispatch(updatePlanModal(false));
  //     dispatch(updatePlanPermissions(response.data.permission_configs));
  //   }

  //   console.log('something went wrong');
  // };

  const fetchPartnerBaseRate = async () => {
    const request = {
      partner_id: partnerId
    };

    const response = await merchantAPI.fetchPartnerBaseRateDetails(request);
    if (!response?.success) {
      Alert('something went wrong', 'Please contact support team for this', 'error');
    }
    sethasData(Object.keys(response?.data?.products || {}).length > 0);
    setProductWiseMode(response?.data?.products);
    setBaseRateUpdateAt(response?.data?.updated_at);
  };

  const handleTabChange = (key) => {
    let tabName = '';
    switch (key) {
      case '1':
        tabName = 'General Settings';
        break;
      case '2':
        tabName = 'Base Rate';
        break;
      case '3':
        tabName = 'Notification';
        break;
      default:
        tabName = 'Unknown Tab';
    }

    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: tabName
    });
  };

  useEffect(() => {
    if (partnerId) {
      fetchPartnerBaseRate();
    }
    trackingService.trackEvent(EVENT_NAME.BUTTON_CLICK, {
      name: 'General Settings'
    });
  }, [partnerId]);

  const items = [
    {
      key: '1',
      label: `General Settings`,
      children: user ? (
        <GeneralSettings style={{ padding: '1px' }} userinfo={user?.currentUser} />
      ) : (
        ''
      )
    },
    hasData && {
      key: '2',
      label: `Base Rate`,
      children: partnerId ? (
        <PartnerBaseRateWrapper
          style={{ padding: '1px' }}
          partnerID={partnerId}
          hasData={hasData}
          productWiseMode={productWiseMode}
          updatedAt={updatedAt}
        />
      ) : (
        'r'
      )
    },
    {
      key: '3',
      label: `Notification`,
      children: user ? <Notifications userinfo={user?.currentUser} /> : ''
    }
    // {
    //   key: '4',
    //   label: `My Subscription`,
    //   children: (
    //     <SubscriptionTab
    //       currentPlan={planType}
    //       currentTenure={currentTenure}
    //       activePlan={activePlan}
    //       isTrialUsed={isTrialUsed}
    //       isTrialActivate={isTrialActivate}
    //       startDate={startDate}
    //       endDate={endDate}
    //     />
    //   )
    // }
  ].filter(Boolean); // Removes `false` if hasData is false

  return <Tabs style={{ padding: '10px 24px' }} items={items} onChange={handleTabChange} />;
}

export default Settings;
